import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@starter/Framework/Common/Utilities/unitHelper";

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

Object.assign(buttonSizeVariants, {
    small: {
        height: 36,
        fontSize: 13,
        padding: pxToRem(6, 14),
        icon: 20,
        iconPadding: 5,
    },
    medium: {
        height: 40,
        fontSize: 14,
        padding: pxToRem(8, 16),
        icon: 22,
        iconPadding: 6,
    },
    large: {
        height: 48,
        fontSize: 16,
        padding: pxToRem(10, 16),
        icon: 24,
        iconPadding: 6,
    },
    xlarge: {
        height: 48,
        fontSize: 18,
        padding: pxToRem(10, 18),
        icon: 26,
        iconPadding: 7,
    },
});
